var _circle, _path, _rect, _circle2, _circle3, _ellipse, _path2, _path3, _path4, _ellipse2, _ellipse3, _path5, _path6, _path7, _g, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelfieIlustracion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    role: "img",
    "aria-label": "Persona tomando una selfie",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#eaf2ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 128c0-24 14-36 32-36s32 12 32 36z",
    fill: "#0168fa"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 78,
    width: 14,
    height: 20,
    rx: 5,
    fill: "#e8b78f"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 62,
    r: 5,
    fill: "#f7d3b4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 62,
    r: 5,
    fill: "#f7d3b4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 62,
    rx: 21,
    ry: 23,
    fill: "#f7d3b4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60c-1-18 9-28 21-28s22 10 21 28c-2-7-6-12-11-14-4 4-15 5-23 2-5 2-7 7-8 12z",
    fill: "#1c273c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56c3-2 7-2 9 0",
    stroke: "#3b4863",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56c2-2 6-2 9 0",
    stroke: "#3b4863",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 63,
    rx: 2.4,
    ry: 3,
    fill: "#1c273c"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72,
    cy: 63,
    rx: 2.4,
    ry: 3,
    fill: "#1c273c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v5",
    stroke: "#e8b78f",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 76c3 4 11 4 14 0",
    stroke: "#c96a4a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116c9-11 11-27 6-44",
    stroke: "#f7d3b4",
    strokeWidth: 11,
    fill: "none",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 93 48)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 28,
    width: 27,
    height: 46,
    rx: 6,
    fill: "#1c273c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 32,
    width: 21,
    height: 38,
    rx: 4,
    fill: "#00b8d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 51,
    r: 6.5,
    fill: "#1c273c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 51,
    r: 2.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 48,
    r: 1.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 66,
    r: 2,
    fill: "#3b4863"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104 22l3 6 6 3-6 3-3 6-3-6-6-3 6-3z",
    fill: "#ffc107"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieIlustracion);
export default __webpack_public_path__ + "static/media/selfieIlustracion.0677132c1d5811ae8502f36e5265e27e.svg";
export { ForwardRef as ReactComponent };